import { createReducer, on, Action } from '@ngrx/store';
import { IPatientPortalLayout } from '@care-portals/api-interfaces';
import * as AppActions from './app.actions';

export const APP_FEATURE_KEY = 'app';

export interface State {
  layout: IPatientPortalLayout;
  loading: boolean;
  error?: any;
}

export interface AppPartialState {
  readonly [APP_FEATURE_KEY]: State;
}

export const initialState: State = {
  layout: null,
  loading: false,
  error: null
};

const appReducer = createReducer(
  initialState,
  on(AppActions.loadAppLayout, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(AppActions.loadAppLayoutSuccess, (state, { layout }) => ({
    ...state,
    loading: false,
    layout
  })),
  on(AppActions.loadAppLayoutFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  }))
);

export function reducer(state: State | undefined, action: Action) {
  return appReducer(state, action);
}
